import { Box } from "@chakra-ui/react"
import { AugmentationToolbarOption } from "@pathwright/ux/src/components/augmentation/AugmentationToolbar"
import UserAvatar from "@pathwright/ux/src/components/avatar/UserAvatar"
import { usePathwrightContext } from "../../pathwright/PathwrightContext"
import UserAugmentation from "./UserAugmentation"
import UserAugmentationChangePassword from "./UserAugmentationChangePassword"
import UserAugmentationPaymentHistory from "./UserAugmentationPaymentHistory"
import UserAugmentationSettings from "./UserAugmentationSettings"

export function useUserAugmentationToolbarOption(): AugmentationToolbarOption {
  const pwContext = usePathwrightContext()

  return {
    key: "settings",
    icon: "gear-fill-2",
    renderIcon: (icon, context) => {
      // For now, let's just render the icon. The Avatar + icon is looking awkward.
      return icon
      return context === "toolbar" ? (
        <Box pos="relative">
          <UserAvatar user={pwContext.me} size="xs" />
          <Box
            pos="absolute"
            bottom="0"
            right="0"
            transform="translate(40%, 40%)"
            fontSize=".75em"
          >
            {icon}
          </Box>
        </Box>
      ) : (
        icon
      )
    },
    tLabel: ["nav.user_menu.settings.label", "Your Settings"],
    AugmentationComponent: UserAugmentation,
    children: [
      {
        key: "profile",
        tLabel: ["nav.user_menu.settings.profile.label", "Profile"],
        AugmentationComponent: UserAugmentationSettings
      },
      {
        key: "password",
        tLabel: ["nav.user_menu.settings.password.label", "Password"],
        AugmentationComponent: UserAugmentationChangePassword
      },
      {
        key: "payment-history",
        tLabel: [
          "nav.user_menu.settings.payment_history.label",
          "Payment History"
        ],
        AugmentationComponent: UserAugmentationPaymentHistory
      }
    ]
  }
}

export default useUserAugmentationToolbarOption
